<style lang="scss" scoped>
@import "./test-tools-home.scss";
</style>

<script>
import { TESTING_TOOLS } from '../../utils/testing-tools'

export default {
  name: 'TestToolsHome',
  data () {
    return {
      tools: TESTING_TOOLS.TOOLS,
      pageDescription: TESTING_TOOLS.PAGE_DESCRIPTION,
      currentEnv: process.env.VUE_APP_ADMIN_KEYS_ENV,
      scrolled: false
    }
  },
  computed: {
    availibilityKey: function () {
      return this.currentEnv + 'Availibility'
    },
    toolUrl: function () {
      return this.currentEnv + 'Url'
    }
  },

  mounted () {
    this.$store.commit('lightBoxloaderOn', false)
    document.title = 'Click to Pay Testing and Support Tools'
    this.tools.sort((a, b) => b.description.length - a.description.length)
  },
  created () {
    window.addEventListener('scroll', this.handleScroll)
  },

  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    navigate (tool) {
      let url =
        this.currentEnv === 'production' ? tool.productionUrl : tool.stageUrl
      window.open(url, '_blank')
    },
    handleScroll () {
      this.scrolled = window.scrollY > 0
    }
  }
}
</script>
<template>
  <div class="container-fluid p-0 tools-home">
    <nav
      id="primary-nav"
      :class="scrolled ? 'scroll' : ''"
      class="
        navbar navbar-light navbar-expand-xl
        py-3
        sticky-top
        bg-white
        border-bottom
      "
    >
      <header class="p-0 container-fluid bg-white">
        <div class="container-xl bg-white d-flex align-items-center">
          <div>
            <a
              data-link-type="internal"
              href="/testingtools">
              <img
                src="@/assets/images/mc_srci.png"
                alt="Logo" >
            </a>
          </div>
          <div class="p-0 title flex-grow-1 text-center">
            <h1 class="font-weight-bold cursor-pointer">
              Click to Pay Testing and Support Tools
            </h1>
          </div>
        </div>
      </header>
    </nav>

    <div class="container-fluid d-flex h-100 p-0 flex-column flex-lg-row">
      <div class="container-xl">
        <div class="align-items-center d-flex">
          <div class="row">
            <div class="col-md-8 mt-5 description">
              <div class="mb-4">
                <h2>The tools you need</h2>
              </div>
              <p class="mb-4">
                {{ pageDescription }}
              </p>
            </div>
          </div>
        </div>

        <div class="pb-6">
          <div class="py-4">
            <div class="row">
              <template v-for="(tool, index) in tools">
                <div
                  v-if="
                    tool[availibilityKey] === 'AVAILABLE'
                  "
                  :key="index"
                  class="col-lg-4 col-md-6 my-3 tool"
                >
                  <div
                    class="card h-100 top-border"
                  >
                    <div class="card-body p-4 d-flex flex-column">
                      <h4
                        class="left-border"
                      >
                        <span class="tool-name">{{ tool.toolName }}</span>
                      </h4>
                      <div
                        class="tool-description mt-4"
                        v-html="tool.description"
                      />
                      <div class="mt-auto">
                        <div class="navigation-link">
                          <router-link
                            v-if="tool.withInApp"
                            :to="tool[toolUrl]"
                            target="_blank"
                            class="mt-3"
                          >
                            <span class="navigate cursor-pointer">
                              Navigate
                              <i
                                class="fa fa-long-arrow-right"
                                aria-hidden="true"
                              />
                            </span>
                          </router-link>
                          <a
                            v-if="!tool.withInApp"
                            class="cursor-pointer link"
                            @click="navigate(tool)"
                          >
                            <span class="navigate pt-3">
                              Navigate
                              <i
                                class="fa fa-long-arrow-right"
                                aria-hidden="true"
                              />
                            </span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footer class="footer-wrap p-0">
      <hr class="m-0">
      <h6 class="font-weight-bold text-center m-0 p-3">
        <span>{{ $t ('label.copyright') }}</span>
        <span>{{ new Date().getFullYear() }}</span>
        <span>&nbsp;{{ $t ('label.copyrightResText') }} </span>
      </h6>
    </footer>
  </div>
</template>
